import React from 'react';
export interface HeadingProps {
  text?: string;
  className?: string;
  as?: React.ElementType;
  children?: React.ReactNode;
}

const TextContent: React.FC<HeadingProps> = ({ text, className = '', as, children, ...props }) => {
  const Component: React.ElementType = as || 'p';
  return (
    <Component
      style={{ overflowWrap: 'anywhere' }}
      className={`text-paragraphSm md:text-paragraphMd text-contentColor whitespace-pre-line ${className}`}
      font-customisation="para-text"
      color-customisation="page-body-text"
      {...props}
    >
      <>
        {text ? text : null}
        {children ? children : null}
      </>
    </Component>
  );
};

export default TextContent;
